<template>
  <section>
    <b-row>
      <b-col md="12">
        <b-card-actions
          :show-loading="saving"
          action-collapse
          :title="`${$t('Dados da Conciliação')} #${reconciliation.id}`"
          class="h-345"
        >
          <b-row>
            <b-col md="3">
              <FormulateInput
                id="reconciliation-payoutId"
                :value="reconciliation.payoutId"
                type="label"
                :label="$t('Pagamento Stripe ID')"
              />
            </b-col>
            <b-col md="3">
              <FormulateInput
                id="reconciliation-checking-account"
                :value="reconciliation.checkingAccount.name"
                type="label"
                :label="$t('Conta Corrente')"
              />
            </b-col>
            <b-col md="2">
              <FormulateInput
                id="reconciliation-movement-date"
                :value="reconciliation.movementDate"
                type="label"
                filter="date"
                :label="$t('Data do Pagamento')"
              />
            </b-col>
            <b-col md="2">
              <FormulateInput
                id="invoice-percent-commission-tax"
                :value="(reconciliation.percentCommissionTax || 0) / 100"
                type="label"
                filter="percentage"
                :label="$t('Taxa Comissão')"
              />
            </b-col>
            <b-col md="2">
              <FormulateInput
                id="invoice-status"
                :value="$t(`Reconciliation_${reconciliation.status}`)"
                type="label"
                :label="$t('Status')"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col md="2">
              <FormulateInput
                id="reconciliation-amount"
                :value="stripeTotalTransactions | currency"
                type="label"
                :label="$t('Valor Transações')"
              />
            </b-col>
            <b-col md="2">
              <FormulateInput
                id="reconciliation-refund"
                :value="stripeTotalRefund | currency"
                type="label"
                :label="$t('Valor Reembolsos')"
              />
            </b-col>
            <b-col md="2">
              <FormulateInput
                id="reconciliation-adjustment"
                :value="stripeTotalAdjustment | currency"
                type="label"
                :label="$t('Valor Disputas/Ajustes')"
              />
            </b-col>
            <b-col md="2">
              <FormulateInput
                id="reconciliation-reservedFund"
                :value="stripeTotalReservedFund | currency"
                type="label"
                :label="$t('Valor Reserva de Fundos')"
              />
            </b-col>
            <b-col md="2">
              <FormulateInput
                id="reconciliation-transfer"
                :value="stripeTotalTransfer | currency"
                type="label"
                :label="$t('Valor Transferências')"
              />
            </b-col>
            <b-col md="2">
              <FormulateInput
                id="reconciliation-amount"
                :value="reconciliation.amount | currency"
                type="label"
                :label="$t('Valor Total Recebido')"
              />
            </b-col>
          </b-row>
        </b-card-actions>
      </b-col>

      <b-col md="12">
          <b-tabs fill>
            <b-tab :title="$t('Transações')">
              <reconciliation-item-table
                :saving="saving"
                :fetching="fetching"
                @get-data="getData"
              />
            </b-tab>

            <b-tab :title="$t('Reembolsos')">
              <reconciliation-refund-item-table
                :fetching="fetchingRefund"
                @get-data="getRefund"
              />
            </b-tab>

            <b-tab :title="$t('Disputas/Ajustes')">
              <reconciliation-adjustment-item-table
                :fetching="fetchingAdjustment"
                @get-data="getAdjustment"
              />
            </b-tab>

            <b-tab :title="$t('Reserva de Fundos')">
              <reconciliation-reservedFund-item-table
                :fetching="fetchingReservedFund"
                @get-data="getReservedFund"
              />
            </b-tab>

            <b-tab :title="$t('Transferências')">
              <reconciliation-transfer-item-table
                :fetching="fetchingTransfer"
                @get-data="getTransfer"
              />
            </b-tab>
          </b-tabs>
        </b-col>
    </b-row>

  </section>
</template>

<script>
import { BRow, BCol, BTabs, BTab  } from 'bootstrap-vue'
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import { mapActions, mapState } from 'vuex'
import { uploader, reconciliationDomains } from '@/mixins'
import ReconciliationItemTable from './components/ReconciliationItemTable.vue'
import ReconciliationAdjustmentItemTable from './components/ReconciliationAdjustmentItemTable.vue'
import ReconciliationRefundItemTable from './components/ReconciliationRefundItemTable.vue'
import ReconciliationReservedFundItemTable from './components/ReconciliationReservedFundItemTable.vue'
import ReconciliationTransferItemTable from './components/ReconciliationTransferItemTable.vue'

export default {
  components: {
    BRow,
    BCol,
    BTabs,
    BTab,
    BCardActions,
    ReconciliationItemTable,
    ReconciliationAdjustmentItemTable,
    ReconciliationRefundItemTable,
    ReconciliationReservedFundItemTable,
    ReconciliationTransferItemTable,
  },

  mixins: [uploader, reconciliationDomains],

  data() {
    return {
      mode: 'xml',
      uploading: false,
      saving: false,
      fetching: false,
      fetchingAdjustment: false,
      fetchingRefund: false,
      fetchingReservedFund: false,
      fetchingTransfer: false,
    }
  },

  computed: {
    ...mapState('pages/financial/reconciliation/stripe/maintain', [
      'reconciliation',
      'summaryFields',
      'summaryAdjustmentFields',
      'summaryRefundFields',
      'summaryReservedFundFields',
      'summaryTransferFields',
    ]),

    reconciliationId() {
      return this.$route.params?.id
    },
    readOnly() {
      return this.reconciliation?.status === 'Completed'
    },
    stripeTotalTransactions() {
      return this.summaryFields?.stripeTotal?.value
    },
    stripeTotalRefund() {
      return this.summaryRefundFields?.stripeTotal?.value
    },
    stripeTotalAdjustment() {
      return this.summaryAdjustmentFields?.stripeTotal?.value
    },
    stripeTotalReservedFund() {
      return this.summaryReservedFundFields?.stripeTotal?.value
    },
    stripeTotalTransfer() {
      return this.summaryTransferFields?.stripeTotal?.value
    },
  },

  created() {
    if (this.reconciliationId) this.cleanState()
  },

  async mounted() {
    if (this.reconciliationId) {
      try {
        this.fetching = true
        await this.fetchReconciliation(this.reconciliationId)
        await this.fetchReconciliationItems(this.reconciliationId)
        await this.fetchReconciliationAdjustmentItems(this.reconciliationId)
        await this.fetchReconciliationRefundItems(this.reconciliationId)
        await this.fetchReconciliationReservedFundItems(this.reconciliationId)
        await this.fetchReconciliationTransferItems(this.reconciliationId)
      } catch (error) {
        this.showError({
          error,
          message: this.$t('Não foi possível obter os dados da conciliação'),
        })
        this.$router.back()
      } finally {
        this.fetching = false
      }
    }
  },

  methods: {
    ...mapActions('pages/financial/reconciliation/stripe/maintain', [
      'fetchReconciliation',
      'fetchReconciliationItems',
      'fetchReconciliationAdjustmentItems',
      'fetchReconciliationRefundItems',
      'fetchReconciliationReservedFundItems',
      'fetchReconciliationTransferItems',
      'cleanState',
    ]),

    async getData() {
      this.$nextTick(async () => {
        try {
          this.fetching = true
          await this.fetchReconciliationItems(this.reconciliationId)
        } catch (error) {
          this.showError({ error })
        } finally {
          this.fetching = false
        }
      })
    },

    async getAdjustment() {
      this.$nextTick(async () => {
        try {
          this.fetchingAdjustment = true
          await this.fetchReconciliationAdjustmentItems(this.reconciliationId)
        } catch (error) {
          this.showError({ error })
        } finally {
          this.fetchingAdjustment = false
        }
      })
    },

    async getRefund() {
      this.$nextTick(async () => {
        try {
          this.fetchingRefund = true
          await this.fetchReconciliationRefundItems(this.reconciliationId)
        } catch (error) {
          this.showError({ error })
        } finally {
          this.fetchingRefund = false
        }
      })
    },

    async getReservedFund() {
      this.$nextTick(async () => {
        try {
          this.fetchingReservedFund = true
          await this.fetchReconciliationReservedFundItems(this.reconciliationId)
        } catch (error) {
          this.showError({ error })
        } finally {
          this.fetchingReservedFund = false
        }
      })
    },

    async getTransfer() {
      this.$nextTick(async () => {
        try {
          this.fetchingTransfer = true
          await this.fetchReconciliationTransferItems(this.reconciliationId)
        } catch (error) {
          this.showError({ error })
        } finally {
          this.fetchingTransfer = false
        }
      })
    },
  },
}
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: 0.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(-20px);
}
/* .h-345 .card {
  min-height: 345px;
} */
</style>
